export default __webpack_public_path__ + "static/media/Untitled_Artwork 2.379ceffa.png";